import React, { useMemo } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { useAccDocuments } from '../../accounting/documents/useData';
import { StatCounterGrid, type StatCounterItem } from './shared';

const statusFilter = (status: string) => ({
  filters: { filters: { status: [status] } },
});

const FinanceOpenItemsCounters: React.FC<{ embedded?: boolean; settings?: Record<string, unknown> }> = ({
  embedded,
}) => {
  const { colors } = useTheme();
  const { total: draftTotal, isLoading: draftLoading } = useAccDocuments(undefined, 1, 1, statusFilter('DRAFT'));
  const { total: tempTotal, isLoading: tempLoading } = useAccDocuments(undefined, 1, 1, statusFilter('TEMP'));
  const { total: savedTotal, isLoading: savedLoading } = useAccDocuments(undefined, 1, 1, statusFilter('SAVED'));

  const isLoading = draftLoading || tempLoading || savedLoading;

  const counters: StatCounterItem[] = useMemo(
    () => [
      {
        key: 'draft',
        label: 'Draft',
        value: draftTotal ?? 0,
        href: '/accounting/journals',
        accent: colors.primary,
      },
      {
        key: 'temp',
        label: 'Temp',
        value: tempTotal ?? 0,
        href: '/accounting/journals',
        accent: 'bg-amber-500',
      },
      {
        key: 'saved',
        label: 'Saved',
        value: savedTotal ?? 0,
        href: '/accounting/journals',
        accent: 'bg-emerald-500',
      },
    ],
    [colors.primary, draftTotal, savedTotal, tempTotal],
  );

  return (
    <StatCounterGrid
      title="Finance · Journals"
      counters={counters}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/accounting/journals"
    />
  );
};

export default FinanceOpenItemsCounters;
